<template>
  <ul class="dropdown">
    <li
      v-for="(item, key) in items"
      :key="key"
      :class="{ active: active_idx == key }"
      @click.stop="activeFun(key, item.text)"
    >
      {{ item.text }}
    </li>
  </ul>
</template>

<script>
export default {
  name: "comDropdown",
  data() {
    return {
      active_idx: NaN
    };
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    activeFun(idx, tag) {
      this.active_idx = idx;
      this.$emit("choose_title", tag);
    }
  }
};
</script>

<style lang="scss" scoped>
.dropdown {
  width: 117px;
  font-size: 14px;
  color: #535353;
  background-color: #ffffff;
  border: 1px solid #ebebeb;
  li {
    width: 100%;
    height: 35px;
    text-align: center;
    line-height: 35px;

    &:hover {
      background-color: #f5f5f5;
    }
  }

  .active {
    background-color: #f5f5f5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/com-dropdown.vue